import React from 'react';
import PropTypes from 'prop-types';

function ScrollBar({ scrollClassNames, scrollIconClassName, scroll }) {
  return (
    <div className={scrollClassNames} onClick={scroll} role='button' aria-hidden>
      <div className='arrow'>
        <span className={scrollIconClassName} />
      </div>
    </div>
  );
}

ScrollBar.propTypes = {
  scrollClassNames: PropTypes.string.isRequired,
  scrollIconClassName: PropTypes.string.isRequired,
  scroll: PropTypes.func.isRequired
};

export default ScrollBar;
